export default __webpack_public_path__ + "static/media/logo-esgari.e8f29c5c.png";